import React, { Component } from "react";
import RoutePath from "../utils/routes/RoutePath";
import { withRouter } from "react-router-dom";
import Constants from "../utils/Constants";
import NoDataFound from "./NoDataFound";

class VendorWard extends Component {
    editWard = (id) => {
        localStorage.setItem("recentOpenedWardId", String(id));
        this.props.history.push("/vendor/ward/edit/" + id);
    }

    render() {
        const { wardList, updateStatus, deleteWard } = this.props;
        const recentOpenedWardId = localStorage.getItem("recentOpenedWardId");
        return (
            <React.Fragment>
                <div className="admin_table">
                    <div role="region" aria-label="data table" tabIndex="0" className="candidate_primary">
                        <table className="dashboard_table">
                            <thead>
                                <tr>
                                    <th className="pin">{Constants.ID}</th>
                                    <th>Ward Name</th>
                                    <th>Ward Nurse</th>
                                    <th>{Constants.ACTION}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {wardList?.length > 0 ?
                                    wardList.map((ward, index) => {
                                        const isRecent = recentOpenedWardId === String(ward?.id);
                                        return <tr key={ward?.id || index} className={isRecent ? "recent-opened-row" : ""}>
                                            <td>{index + 1}</td>
                                            <td>{ward?.wardName}</td>
                                            <td>{ward?.HeadUser?.fullName || ward?.HeadUser?.email || '-'}</td>
                                            <td>
                                                <i className="fa-solid fa-pen-to-square updateIcon edit-icon" onClick={() => this.editWard(ward?.id)} title="Edit" />
                                                <i
                                                    className={Number(ward?.isActive) === 1 ? "fa-solid fa-toggle-on toggle-icon ms-2 edit-icon" : "fa-solid fa-toggle-off toggle-icon ms-2 edit-icon"}
                                                    onClick={() => updateStatus(ward?.id, ward?.isActive)}
                                                    title={Number(ward?.isActive) === 1 ? "Deactivate" : "Activate"}
                                                />
                                                {deleteWard ? (
                                                    <i
                                                        className="fa-solid fa-trash ms-2 edit-icon"
                                                        title={Constants.DELETE_WARD_TITLE}
                                                        onClick={() => deleteWard(ward)}
                                                    />
                                                ) : null}
                                            </td>
                                        </tr>
                                    }) : <NoDataFound />
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withRouter(VendorWard);
